// sets a flash animation on click of a specific area

export function touchEffect() {
    const buttons = document.querySelectorAll<HTMLElement>(
        ".squarelist a, .table-list ul a",
    );

    if (buttons.length > 0) {
        buttons.forEach((button) => {
            button.addEventListener("click", async (e: MouseEvent) => {
                applyCursorRippleEffect(e);
            });
        });
    }

    function applyCursorRippleEffect(e: MouseEvent) {
        const ripple = document.createElement("span");
        const target = e.target as HTMLElement;
        const diameter = Math.max(target.clientWidth, target.clientHeight);
        const radius = diameter / 2;
        const existingRippleToRemove =
            document.querySelectorAll<HTMLElement>(".ripple");

        if (existingRippleToRemove) {
            existingRippleToRemove.forEach((buttonToRemove) => {
                buttonToRemove.remove();
            });
        }

        ripple.style.width = ripple.style.height = `${diameter}px`;
        ripple.style.left = `${e.clientX - (target.offsetLeft + radius)}px`;
        ripple.style.top = `${e.clientY - (target.offsetTop + radius)}px`;
        ripple.classList.add("ripple");

        target.appendChild(ripple);
    }
}
